export type UiTextDictionaryId =
  | "default"
  | "medical"
  | "sales"
  | "recruitment";
export type UITextKey =
  | "shop"
  | "customer"
  | "customer_visit"
  | "questionnaire";

export type UITextDictionary = {
  id: UiTextDictionaryId; // 辞書ID
  name: string; // 表示名 (例: "一般", "医療機関")
  description: string; // 説明
  texts: Record<UITextKey, string>; // すべてのキーが必須
};

const uiTextDictionaries: Record<UiTextDictionaryId, UITextDictionary> = {
  default: {
    id: "default",
    name: "一般",
    description: "一般的な業種向けのUIテキスト",
    texts: {
      shop: "店舗",
      customer: "顧客",
      customer_visit: "来店",
      questionnaire: "質問票",
    },
  },
  medical: {
    id: "medical",
    name: "医療機関",
    description: "医療機関向けのUIテキスト",
    texts: {
      shop: "医療機関",
      customer: "患者",
      customer_visit: "来院",
      questionnaire: "問診票",
    },
  },
  sales: {
    id: "sales",
    name: "営業",
    description: "営業向けのUIテキスト",
    texts: {
      shop: "店舗",
      customer: "顧客",
      customer_visit: "面談",
      questionnaire: "質問票",
    },
  },
  recruitment: {
    id: "recruitment",
    name: "人事採用",
    description: "人事採用向けのUIテキスト",
    texts: {
      shop: "店舗",
      customer: "応募者",
      customer_visit: "面談",
      questionnaire: "質問票",
    },
  },
};

export const isValidUITextDictionaryId = (
  id: string | undefined,
): id is UiTextDictionaryId => {
  if (!id) {
    return false;
  }
  return Object.keys(uiTextDictionaries).includes(id);
};

export const getUITextDictionary = (
  id: UiTextDictionaryId,
): UITextDictionary => {
  return uiTextDictionaries[id] || uiTextDictionaries.default;
};
